import { useState } from 'react';
import Modal from '../../../Modals/Modal';
import { useLanguage } from '../../../../context/LanguageContext';
import styles from './CreateTableModal.module.css';

interface CreateTableModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (name: string, dbName: string) => Promise<void>;
}

export default function CreateTableModal({
  isOpen,
  onClose,
  onSubmit
}: CreateTableModalProps) {
  const { t } = useLanguage();
  const [tableName, setTableName] = useState("");
  const [tableDbName, setTableDbName] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!tableName.trim() || !tableDbName.trim()) {
      alert(t('fillAllFields'));
      return;
    }

    try {
      setIsSubmitting(true);
      await onSubmit(tableName, tableDbName);

      setTableName("");
      setTableDbName("");
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (!isSubmitting) {
      setTableName("");
      setTableDbName("");
      onClose();
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={t('createNewTable')}
      closeOnOverlayClick={!isSubmitting}
    >
      <form className={styles.form} onSubmit={handleSubmit}>
        <div className={styles.formGroup}>
          <label htmlFor="tableName">{t('tableName')}</label>
          <input
            id="tableName"
            type="text"
            value={tableName}
            onChange={(e) => setTableName(e.target.value)}
            placeholder={t('tableNamePlaceholder')}
            autoFocus
            disabled={isSubmitting}
            className={styles.input}
          />
        </div>

        <div className={styles.formGroup}>
          <label htmlFor="tableDbName">
            {t('tableDbName')}
          </label>
          <input
            id="tableDbName"
            type="text"
            value={tableDbName}
            onChange={(e) =>
              setTableDbName(e.target.value.toLowerCase().replace(/[^a-z\-0-9_]/g, ''))
            }
            placeholder={t('tableDbNamePlaceholder')}
            disabled={isSubmitting}
            className={styles.input}
          />
          <small className={styles.hint}>
            {t('tableDbNameHint')}
          </small>
        </div>

        <div className={styles.actions}>
          <button
            type="button"
            className={styles.cancelBtn}
            onClick={handleClose}
            disabled={isSubmitting}
          >
            {t('cancel')}
          </button>
          <button
            type="submit"
            className={styles.submitBtn}
            disabled={!tableName.trim() || !tableDbName.trim() || isSubmitting}
          >
            {isSubmitting ? t('creating') : t('create')}
          </button>
        </div>
      </form>
    </Modal>
  );
}